import React from "react";
import { Phone, Calendar } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-zinc-950/95 backdrop-blur-xl border-t border-zinc-800 p-3 flex gap-2"
      data-testid="mobile-sticky-cta"
    >
      <a
        href="tel:+17079090231"
        data-testid="sticky-call-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full border border-zinc-700 text-zinc-100 font-semibold text-sm hover:border-cyan-400 hover:text-cyan-400 transition-all"
      >
        <Phone className="h-4 w-4" /> Call / Text
      </a>
      <a
        href="#booking"
        data-testid="sticky-book-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-cyan-400 text-zinc-950 font-bold text-sm shadow-[0_0_20px_rgba(34,211,238,0.4)]"
      >
        <Calendar className="h-4 w-4" /> Book Now
      </a>
    </div>
  );
}
